export const parseEmpty = (text: string) => {
  if (Boolean(text?.trim())) {
    return text;
  }
  return "";
};
export const importantStyle = (text: string) => {
  return text + "!important";
};
export const accountingFormat = (number: number) => {
  return new Intl.NumberFormat("de-DE").format(number);
};

export const toProxyURL = (url: string): string => {
  // Return original URL if it's not a valid HTTP/HTTPS URL
  if (!url || typeof url !== "string") {
    return url || "";
  }

  // Skip proxy for local URLs, data URLs, and blob URLs
  if (
    url.startsWith("data:") ||
    url.startsWith("blob:") ||
    url.startsWith("/") ||
    !url.startsWith("http")
  ) {
    return url;
  }

  // Use proxy for external URLs
  const apiUrl = process.env.REACT_APP_SERVER_LINK || "http://localhost:6055/api";
  if (!apiUrl) {
    console.warn("REACT_APP_API_URL not configured, using original URL");
    return url;
  }

  return `${apiUrl}/proxy/?url=${encodeURIComponent(url)}`;
};
